import React from "react"
import Util from "../../../util/util"
import { professionData } from "../../../data/overview"
const echarts = window.echarts
export default class UserFlow extends React.Component {
  componentDidMount() {
    // 基于准备好的dom，初始化echarts实例
    var mc = (this.myChart = echarts.init(this.refs.$con))
    var opts = {
      // title: {
      //   text: "用户信息",
      //   left: "left",
      //   textStyle: {
      //     fontSize: 14,
      //     color: "rgb(67,148,190)",
      //   },
      // },
      grid: {
        left: "1%",
        right: "1%",
        bottom: "10",
        top: 10,
      },
      tooltip: {
        trigger: "item",
        // formatter:'{b}:{d}%',
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#283b56",
          },
        },
      },
      series: [
        {
          type: "pie",
          radius: ["10%", "40%"],
          color: ["#ec5d51", "#59abe1"],
          data: professionData[0],
          label: {
            normal: {
              position: "inner",
              fontStyle: "normal",
              fontSize: 10,
              formatter: "{b}\n{d}%",
            },
          },
        },
        {
          type: "pie",
          radius: ["44%", "68%"],
          color: [
            "#a0dca0",
            "#60bbb6",
            "#f78db3",
            "#feadac",
            "#fae395",
            "#91d4e5",
            "#8eb3e8",
            "rgba(226, 99, 74, 0.7)",
          ],
          label: {
            normal: {
              show: true,
              fontStyle: "normal",
              fontSize: 10,
              formatter: "{b}\n{d}%",
            },
          },
          data: professionData[1],
        },
      ],
    }
    mc.setOption(opts)
    Util.registerChartsResize(mc)
    // this.refreshChart()
  }
  componentWillUnmount() {
    Util.destroyCharts(this.myChart)
  }
  render() {
    return <div ref="$con" style={{ height: "100%" }} />
  }
}
